module.exports = __webpack_public_path__ + "static/img/maynika.c2c6089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/maynika.jpg
// module id = 208
// module chunks = 1